<template>
  <div class="searchPage">
    <topNav ref="topnav"
            :title="isMultSelect? mutlSelectTitle : search_title"
            :selectMore="true"
            operateTextConfirm='determine'
            @goSelect="goSelect"
            @operateMultSelected="operateMultSelected"
            @cancleSelectMore="cancleSelectMore"></topNav>

    <searchHotel :isMultSelect='isMultSelect'
                 :allowSelectOpera="true"
                 from="pageHeader"
                 @selectMultItem='selectMultItem'
                 @selectHotel="setHotel"
                 @setHotelLcg="setHotelLcg"
    ></searchHotel>
  </div>
</template>
<script>
  import searchHotel from "../common/searchHotel";
  import _ from 'underscore'
  import Vue from "vue";

  export default {
    data() {
      return {
        isMultSelect: false,
        multChoicedArr: [],
      };
    },

    computed: {
      search_title() {
        return this.$t("search_title");
      },
      mutlSelectTitle() {
        return this.$t('fangT_mutlSelectTitleText') + this.multChoicedArr.length + this.$t('fangT_mutlSelectTitUnit')
      },
    },
    mounted() {
    },
    methods: {
      goSelect() {
        this.isMultSelect = true;
        this.multChoicedArr = [];
      },
      operateMultSelected() {
        if (!this.multChoicedArr.length) {
          this.msg2(this.$t('contrll_at_least'))
        } else {
          let codes = _.pluck(this.multChoicedArr, 'code') || []
          let param = {
            level: 300,
            code: codes.join(','),
            descript: this.$t('contrll_self_choice') + codes.length + this.$t('contrll_num_hotel')
          }
          this.setHotel(param)
        }
      },
      cancleSelectMore() {
        this.isMultSelect = false;
        this.multChoicedArr = []
      },
      selectMultItem(selectedItem) {
        if (this.hasItem(selectedItem)) {
          this.multChoicedArr.map((item, index) => {
            if (item.code == selectedItem.code) {
              this.multChoicedArr.splice(index, 1)
            }
          })
        } else {
          this.multChoicedArr.push(selectedItem)
        }
      },

      hasItem(selectedItem) {
        let flag = false
        this.multChoicedArr.map((item, index) => {
          if (item.code == selectedItem.code) {
            flag = true
          }
        })
        return flag
      },

      setHotel(item, type) {
        localStorage.setItem('currentMiHotel',JSON.stringify(item));//缓存当前选中的酒店信息 即主页的酒店
        localStorage.setItem('currentLichengCode', item.code)
        localStorage.setItem('isLiCheng', (item.isLiCheng == 'true') ? 'yes' : 'no')

        var url = '/mobilepmsapi/sys/switchHotel'
        if(type == 'lcg'){
          url = '/mobilepmsapi/sys/switchHotelForLcg'
        }
        this.$http.post(url, item).then(res => {
          if (res.data.result == 0) {
            var retVal = res.data.retVal || {}
            localStorage.setItem('switchHotelInfo', JSON.stringify(retVal))

            localStorage.removeItem("operaMyList");
            this.$store.commit("operaMyList", []);
            localStorage.removeItem("myList");
            this.$store.commit("setMyList", []);

            if (item.opera) {
              this.$setIsOpera()
              this.$router.push("/opera/");
            } else {
              this.$setIsNotOpera()
              this.$router.push("/");
            }
          } else {
            this.msg2(res.data.msg);
          }
        });
      },

      setHotelLcg(item) {
        this.setHotel(item, 'lcg')
      }
    },
    components: {
      searchHotel
    }
  };
</script>

<style lang='less'>
  .searchPage {
  }
</style>



// WEBPACK FOOTER //
// search.vue?b28371f0